import React, { useEffect, useState, useContext } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import ClassBanner from '../../Shared/ClassBanner/ClassBanner';
import { Box, Grid, Link, Paper, Typography } from '@material-ui/core';
import { PinDrop as PinDropIcon } from '@material-ui/icons';

import NewsfeedForm from './NewsfeedForm/NewsfeedForm';
import NewsfeedItem from './NewsfeedItem/NewsfeedItem';

import { StateContext, DispatchContext } from '../../../context/Provider';

const NoPostsFound = () => {
    return (
        <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
            <Paper>
                <Box px={2} py={5}>
                    <Typography variant="body2" color="textSecondary" component="p" align="center">
                        No post/s found.
                    </Typography>
                </Box>
            </Paper>
        </Grid>
    );
}

const Newsfeed = (props) => {

    const { classcode } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState, globalState } = appState;
    const { globalDispatch } = appDispatch;

    const [isFormOpen, setIsFormOpen] = useState(false);
    let newsfeedForm = null;
    if (isFormOpen) {
        newsfeedForm = <NewsfeedForm/>;
    }

    const [classroom, setClassroom] = useState(null);
    const [announcements, setAnnouncements] = useState([]);
    const [pinnedPostsCount, setPinnedPostsCount] = useState(0);

    const handleCloseForm = () => {
        setIsFormOpen(!isFormOpen);
    }

    async function fetchAnnouncements() {

        try {

            const response = await axiosConfig.get(`/announcements?classcode=${classcode}`);
            const { data } = response.data;

            setClassroom(data.classroom);
            setAnnouncements(data.announcements);
            setPinnedPostsCount(data.pinnedPostsCount);

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function fetchPinnedPosts() {
        console.log('fetching pinned posts...');
    }

    const PinnedPostsHeading = () => {
        return (
            <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                <Typography variant="body1" color="textSecondary">Pinned posts</Typography>
            </Grid>
        );
    }

    useEffect(() => {

        if (!classcode) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 0});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchAnnouncements();
        return () => {
            source.cancel();
        }

        // setTimeout(() => globalDispatch({type: 'setIsLoading', value: false}), 500);

    }, []);

    return (
        <ResponsiveLayout classcode={classcode}>
            { classroom ? (
                <>
                    {/* <pre>{JSON.stringify(classroom, null, 2)}</pre> */}
                    <Box mt={2} />
                    <Grid
                        container
                        spacing={2}
                        justify="center"
                    >
                        <ClassBanner
                            classroomName={classroom.name}
                            sectionName={classroom.section}
                            classcode={classcode}
                            themeColor={classroom.theme_color}
                        />

                        { authState.user.role_id !== 3 && (
                            <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                                <Paper elevation={1}>
                                    <Box p={2}>
                                        {
                                            !isFormOpen ?
                                                (<Typography>
                                                    <Link href="#" color="inherit" variant="body2" onClick={(e) => { setIsFormOpen(!isFormOpen) }}>
                                                        What's on your mind?
                                                    </Link>
                                                </Typography>)
                                            :  (<NewsfeedForm
                                                    classcode={classcode}
                                                    fetchAnnouncements={fetchAnnouncements}
                                                    handleCloseForm={handleCloseForm}
                                                />)
                                        }
                                    </Box>
                                </Paper>
                            </Grid>
                        )}

                        { pinnedPostsCount > 0 ? <PinnedPostsHeading /> : null }
                        {announcements.map((announcement, i) => (
                            announcement.is_pinned ?
                                <NewsfeedItem
                                    key={i}
                                    announcement={announcement}
                                    fetchAnnouncements={fetchAnnouncements}
                                />
                            : null
                        ))}

                        { announcements.length === 0 ? <NoPostsFound /> : null }

                        <Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
                            <Typography variant="body1" color="textSecondary">Recent activity</Typography>
                        </Grid>

                        {/* { announcements.map((announcement, i) => (
                            <NewsfeedItem
                                key={i}
                                announcement={announcement}
                                fetchAnnouncements={fetchAnnouncements}
                            />
                        ))} */}

                        {announcements.map((announcement, i) => (
                            !announcement.is_pinned ?
                                <NewsfeedItem
                                    key={i}
                                    announcement={announcement}
                                    fetchAnnouncements={fetchAnnouncements}
                                />
                            : null
                        ))}

                    </Grid>
                </> ) : null
            }
        </ResponsiveLayout>
    );
}

export default Newsfeed;